import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router' 
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import Vant from 'vant'
import 'vant/lib/index.css'
import { i18n,  init as i18nInit } from './i18n/index';
// Import locale
import { Locale } from 'vant'
import ptBR from 'vant/es/locale/lang/pt-BR'  // Portuguese (Brazil)
import './registerServiceWorker'
// Apply locale globally
Locale.use('pt-BR', ptBR)

const app = createApp(App)
const pinia = createPinia();

// Initialize i18n
i18nInit();

pinia.use(piniaPluginPersistedstate);
app.use(pinia);
app.use(Vant);
app.use(router);
app.use(i18n);
app.mount('#app')
